import React from 'react';
import { Box, CircularProgress, FormControl, IconButton, Popper, Stack, TextField, Typography, useTheme } from '@mui/material';
import { useFetchAllTasksQuery, useFetchAllTasksTagsQuery } from '../../../../../services/projectTasksApi';
import { useState } from 'react';
import { ExtendedProjectTask } from './types';
import ProjectTaskDataGrid from './ProjectTaskDataGrid';

interface TaskSelectionDialogProps {
	open: boolean;
	onClose: () => void;
	onSelect: (task: ExtendedProjectTask) => void;
	anchorEl: HTMLElement | null;
}

const TaskSelectionDialog: React.FC<TaskSelectionDialogProps> = ({ open, onClose, onSelect, anchorEl }) => {
	const theme = useTheme();
	const { data: tasks, error, isLoading } = useFetchAllTasksQuery({});
	const { data: tags, isLoading: isTagsLoading } = useFetchAllTasksTagsQuery({});

	const [filterName, setFilterName] = useState('');
	const [filterTags, setFilterTags] = useState<string[]>([]);

	const handleSelect = (task: ExtendedProjectTask) => {
		onSelect(task);
		onClose();
	};

	return (
		<Popper
			open={open}
			anchorEl={anchorEl}
			placement='bottom-start'
			sx={{
				zIndex: 99999,
				width: anchorEl ? Math.max(anchorEl.getBoundingClientRect().width, 1200) : '75rem',
				minWidth: '500px',
				maxWidth: '90vw',
			}}
		>
			<Box
				sx={{
					border: 1,
					borderColor: 'divider',
					bgcolor: 'background.paper',
					boxShadow: 3,
					borderRadius: 1,
					mt: 1,
					maxHeight: '80vh',
					overflow: 'auto',
					p: 2,
				}}
			>
				<Stack direction='row' alignItems='space-between' sx={{ mb: 2 }}>
					<Typography sx={{ flexGrow: 1, fontSize: '1.15rem', fontWeight: 600, color: theme.palette.primary.main }}>
						Valitse tehtävä
					</Typography>
				</Stack>

				<FormControl fullWidth>
					<TextField
						variant='standard'
						placeholder='Vapaasanahaku...'
						value={filterName}
						onChange={e => setFilterName(e.target.value)}
						sx={{ mb: '1rem' }}
					/>
				</FormControl>

				<Box sx={{ height: '60vh', overflow: 'auto' }}>
					{tasks && (
						<ProjectTaskDataGrid tasks={tasks} filterName={filterName} filterTags={filterTags} onRowSelect={handleSelect} />
					)}
					{isLoading && (
						<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
							<CircularProgress />
						</Box>
					)}
					{error && <Typography color='error'>Error loading tasks</Typography>}
				</Box>
			</Box>
		</Popper>
	);
};

export default TaskSelectionDialog;
